module.exports = __webpack_public_path__ + "img/InsanityMax30.a288a49c.jpg";